// project imports
import * as actionTypes from "./actions";

export const initialState = {
  grids: [],
  tiles: [],
};

const computingViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_GRIDS:
      return {
        ...state,
        grids: action.value,
      };
    case actionTypes.SET_TILES:
      return {
        ...state,
        tiles: action.value,
      };
    default:
      return state;
  }
};

export default computingViewReducer;
